import { select } from "d3-selection";
/**
  Given an HTMLElement and a "width" or "height" string, this function returns the current calculated size for the DOM element.
  @private
*/ function _elementSize(element, s) {
    if (!element) return undefined;
    if (element.tagName === undefined || [
        "BODY",
        "HTML"
    ].indexOf(element.tagName) >= 0) {
        var val = window["inner".concat(s.charAt(0).toUpperCase() + s.slice(1))];
        var elem = select(element);
        if (s === "width") {
            val -= parseFloat(elem.style("margin-left"));
            val -= parseFloat(elem.style("margin-right"));
            val -= parseFloat(elem.style("padding-left"));
            val -= parseFloat(elem.style("padding-right"));
        } else {
            val -= parseFloat(elem.style("margin-top"));
            val -= parseFloat(elem.style("margin-bottom"));
            val -= parseFloat(elem.style("padding-top"));
            val -= parseFloat(elem.style("padding-bottom"));
        }
        return val;
    } else {
        var val1 = element.getBoundingClientRect()[s];
        if (typeof val1 === "number" && val1 > 0) {
            if (s === "height") {
                val1 -= parseFloat(select(element).style("padding-top"));
                val1 -= parseFloat(select(element).style("padding-bottom"));
                val1 -= parseFloat(select(element).style("border-top"));
                val1 -= parseFloat(select(element).style("border-bottom"));
            } else {
                val1 -= parseFloat(select(element).style("padding-left"));
                val1 -= parseFloat(select(element).style("padding-right"));
                val1 -= parseFloat(select(element).style("border-left"));
                val1 -= parseFloat(select(element).style("border-right"));
            }
            return val1;
        } else return _elementSize(element.parentNode, s);
    }
}
/**
    Finds the available width and height for a specified HTMLElement, traversing it's parents until it finds something with constrained dimensions. Falls back to the inner dimensions of the browser window if none is found.
    @private
*/ export default function(elem) {
    return [
        _elementSize(elem, "width"),
        _elementSize(elem, "height")
    ];
}

//# sourceMappingURL=getSize.js.map